module.exports = __webpack_public_path__ + "img/1.fc8bffc3.jpg";